import React from 'react';
import Icon from '../icon/index.jsx';

const ContactCard = (item, showLessLabel, showMoreLabel) => {
    const contact = item.searchHitObject.properties;
    const [showInfo, setShowInfo] = React.useState(false);
    const [initalProductAreas, setInitalProductAreas] = React.useState(2);
    return (
        <>
            <div className="contact-card contact-card--person ">
                <div className="contact-card__body">
                    {contact.ProfileImage && contact.ProfileImage.url &&
                        <div className="contact-card__top-img">
                            <img src={contact.ProfileImage.url} alt="Contact Page Image" className="contact-card__image" />
                        </div>
                    }
                    <strong className="contact-card__label">{contact.FirstName} {contact.LastName}</strong>
                    <div className="contact-card__bottom-body">
                        <div className="contact-card__role">{contact.Roles && contact.Roles.value && contact.Roles.value[0].name}</div>
                        {contact.Roles && contact.Roles.value && contact.Roles.value.length > 0 &&
                            contact.Roles.value.slice(1, 3).map((role) => {
                                return <div>{role.name}</div>;
                            })
                        }
                    </div>
                    {contact.ProductAreas && contact.ProductAreas.value && contact.ProductAreas.value.length > 0 &&
                        <div className='contact-card__product-area'>
                            {contact.AdditionalInfoText &&
                                <div className='contact-card__additional-info'>{contact.AdditionalInfoText}</div>
                            }

                            <div className='contact-card__product-area-list'>
                                {contact.ProductAreas && contact.ProductAreas.value && contact.ProductAreas.value.slice(0, initalProductAreas).map((area) => {
                                    return <span className='contact-card__product-area-item'>{area.name}</span>;
                                })}
                            </div>
                            {contact.ProductAreas && contact.ProductAreas.value && contact.ProductAreas.value.length > initalProductAreas && (
                                <button className='contact-card__show-more-button' onClick={() => setInitalProductAreas(999)}>Visa fler</button>
                            )}
                        </div>
                    }
                </div>
                {showInfo &&
                    <div className="show-info js-show-info">
                        <div className="show-info__wrapper js-show-info-wrapper">
                            <div className="show-info__content">
                                <ul className="contact-list">
                                    {contact.Offices.value[0].name && <li className="contact-list__item">
                                        <Icon icon="map-pin" additionalClasses="icon contact-list__icon"></Icon>
                                        {contact.Offices.value[0].name}
                                    </li>
                                    }
                                    {contact.PhoneList && contact.PhoneList.map((number, i) => {
                                        return <li key={number.number + '-' + i} className="contact-list__item">
                                            <a href={`tel:${number}`}>
                                                <Icon icon="phone" additionalClasses="icon contact-list__icon"></Icon>
                                                {number.number}
                                            </a>
                                        </li>;
                                    })
                                    }
                                    {contact.Email &&
                                        <li className="contact-list__item">
                                            <a href={`mailto:${contact.Email}`}>
                                                <Icon icon="mail" additionalClasses="icon contact-list__icon"></Icon>
                                                {contact.Email}
                                            </a>
                                        </li>
                                    }

                                </ul>
                            </div>
                        </div>
                    </div >
                }
                <div class="show-info__btn-holder js-show-info-btn-holder">
                    <button class="show-info__btn js-show-info-btn" onClick={() => setShowInfo(!showInfo)}>
                        {showInfo ? showLessLabel : showMoreLabel}
                        <Icon icon='close' additionalClasses={`show-info__btn-icon ${showInfo ? 'active' : ''}`} ></Icon>
                    </button>
                </div >
            </div >
        </>
    );

};

export default ContactCard;
